const listCollectionsSwatchGender = document.querySelectorAll('.collections__switch--gender');

listCollectionsSwatchGender.forEach(el => {
  el.addEventListener('click', function() {

    if (!el.classList.contains('active')) {
      const getGender = this.getAttribute('data-gender');
      const CollectionsSlider = this.closest('.main-bundles-switcher').querySelector('.collections__switch--slider');
      const mensGenderCollection = this.closest('.main-bundles-switcher').querySelectorAll('.product-card--men');
      const womensGenderCollection = this.closest('.main-bundles-switcher').querySelectorAll('.product-card--women');
      
      // 1- Remove Active Class 
      el.closest('.collections__switch').querySelectorAll('.collections__switch--gender').forEach(btn => btn.classList.remove('active'));


      // 2- Add Active Class
      this.classList.add('active');

      // 3- Update Slider & Collection
      if (getGender == 'mens') {
        // Update Slider
        CollectionsSlider.classList.remove('active-womens');
        CollectionsSlider.classList.add('active-mens');

        // Update Collection
        mensGenderCollection.forEach(el => el.classList.remove('hidden'));
        womensGenderCollection.forEach(el => el.classList.add('hidden'));

      } else if (getGender == 'womens') {
        // Update Slider
        CollectionsSlider.classList.remove('active-mens');
        CollectionsSlider.classList.add('active-womens');

        // Update Collection
        womensGenderCollection.forEach(el => el.classList.remove('hidden'));
        mensGenderCollection.forEach(el => el.classList.add('hidden'));
      } 
    }
  })
});


document.addEventListener("DOMContentLoaded", function () {
  function hasURLParameter(param, value) {
      const urlParams = new URLSearchParams(window.location.search);
      return urlParams.get(param)?.toLowerCase() === value;
  }

  if (hasURLParameter("load", "women")) {
      document.querySelector(".collections__switch--gender[data-gender='womens']").click();
  } 
  
  document.querySelector(".main-bundles-switcher").classList.remove("blank");


});
